<template>
  <ListLayout
    :title="`${configurationModule.fieldConfiguration}`"
    :context="context"
    :tableData="fieldConfigurationList"
    :tableHeader="tableHeaders"
    :total="totalItems"
    @getList="getFieldConfigurationList"
  >
    <template #listAction>
      <!-- <v-btn
        @click="openDownloadDialog = true"
        color="primary"
        class="white--text mr-2"
        depressed
      >
        <v-icon>mdi-download</v-icon>
        <span class="text-body-2">Download</span>
      </v-btn> -->
      <PrimaryButton
        id="fieldConfigurationAdd"
        v-if="permissions && permissions.add"
        @click="addFieldConfiguration"
        :name="`Add ${configurationModule.fieldConfiguration}`"
        icon="mdi-plus"
        iconSize="x-large"
      >
      </PrimaryButton>
    </template>
    <template #dialogs>
      <FieldConfigurationForm
        :editMode="isEditing"
        :fieldConfigurationID="selectedFieldConfigurationID"
        v-model="showFieldConfigurationForm"
        @refreshList="getFieldConfigurationList"
      />
    </template>
  </ListLayout>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import { bus } from "@/main.js";
import FieldConfigurationButton from "@/components/Button/FieldConfigurationButton.vue";
import ListLayout from "@/components/LayoutComponents/ListLayout.vue";
import FieldConfigurationForm from "@/components/ModuleBasedComponents/FieldConfiguration/FieldConfigurationForm.vue";
import { configurationModule } from "@/utils/moduleMapping";

export default {
  components: {
    FieldConfigurationButton,
    ListLayout,
    FieldConfigurationForm,
  },
  data() {
    return {
      configurationModule,
      permissions: null,
      sorting: {},
      openDownloadDialog: false,
      pageNo: 1,
      totalItems: 0,
      filters: this.$helper.getFilterFromLocalStorage(
        "fieldConfigurationFilters"
      ),
      isChipsVisible: false,
      fieldConfigurationList: [],
      headerSelected: [
        {
          headerName: "Module",
          field: "module",
          sortable: false,
        },
        {
          headerName: "Keyword",
          field: "keyword",
          sortable: false,
        },
        {
          headerName: "Label",
          field: "name",
          sortable: false,
          cellClass: "text-capitalize",
        },
        {
          headerName: "description",
          field: "description",
          sortable: false,
          tooltipField: "description",
          cellClass: "text-capitalize",
        },
      ],

      isEditing: false,
      showFieldConfigurationForm: false,
      selectedFieldConfigurationID: null,

      showBulkUploadDialog: false,
    };
  },
  computed: {
    tableHeaders() {
      return [
        ...this.headerSelected,
        {
          headerName: "Actions",
          field: "actions",
          pinned: "right",
          sortable: false,
          minWidth: 110,
          width: 110,
          cellRenderer: "FieldConfigurationButton",
        },
      ];
    },
    context() {
      return { parentComponent: this };
    },
  },
  methods: {
    getFieldConfigurationList(params = {}) {
      bus.$emit("showLoader", true);
      params = {
        limit: this.$globalConstant.itemsPerPage,
        offset: 0,
        ...params,
        ...this.filters,
      };

      // if ("ordering" in params && params.ordering.length > 0) {
      //   params = { ...params, ordering: params.ordering.join(",") };
      // }
      if ("unit" in params && params.unit.length > 0) {
        params = { ...params, unit: params.unit.join(",") };
      }

      this.isChipsVisible = Object.keys(this.filters).length > 0;

      this.$api.fieldConfiguration
        .getFieldConfigurationList(params)
        .then((res) => {
          this.fieldConfigurationList = res.data;
          this.totalItems = res.count;
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
    addFieldConfiguration() {
      this.selectedFieldConfigurationID = null;
      this.isEditing = false;
      this.showFieldConfigurationForm = true;
    },
    editFieldConfiguration(id) {
      this.selectedFieldConfigurationID = id;
      this.isEditing = true;
      this.showFieldConfigurationForm = true;
    },
    deleteFieldConfiguration(id) {
      bus.$emit("showLoader", true);
      this.$api.fieldConfiguration
        .deleteFieldConfigurationObject(id)
        .then(() => {
          this.getFieldConfigurationList();
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.log(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  created() {
    this.permissions = this.$permissions.getPermission("configuration");
  },
};
</script>
